import * as actionTypes from './actionTypes'

// If 'concatenate' is set to true, then the 'newBreadcrumbs' 
// will be added to the existing custom breadcrumbs
const updateCustomBreadcrumbs = (newBreadcrumbs, concatenate = false) => ({
    type: actionTypes.UPDATE_CUSTOM_BREADCRUMBS,
    payload: {
        newBreadcrumbs,
        concatenate
    }
});

const updateCustomTitle = newTitle => ({
    type: actionTypes.UPDATE_TOP_HEADER_TITLE,
    payload: newTitle
});

export default {
    updateCustomBreadcrumbs,
    updateCustomTitle
}